<template>
  <div class="navs-container">
    <Nav :menu="menu" />

    <div class="navs-more-btn" @click="show = true">
      <div class="navs-more-icon"></div>
    </div>

    <van-popup closeable v-model="show" position="bottom" class="popup-container">
      <div class="popup-title">频道</div>

      <van-grid :column-num="3" class="popup-grid">
        <van-grid-item
          v-for="value in menu"
          :class="$route.name === value.name ? 'active' : ''"
          @click="show = false"
          :clickable="false"
          :key="value.id"
          icon="photo-o"
          :text="value.meta.title"
          :to="value.path"
        >
          <template slot="icon">
            <i :class="value.meta.icon"></i>
          </template>
        </van-grid-item>
        <van-grid-item @click="onJump('https://epaper.cs.com.cn/dnis/acl.jsp', 0)" :clickable="false" icon="photo-o" text="电子报">
          <template slot="icon">
            <i class="icon-dzb"></i>
          </template>
        </van-grid-item>
        <van-grid-item @click="onJump('https://www.cs.com.cn/roadshow/', 1)" :clickable="false" icon="photo-o" text="路演">
          <template slot="icon">
            <i class="icon-ly"></i>
          </template>
        </van-grid-item>
      </van-grid>
    </van-popup>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
export default {
  name: "MenuView",
  components: {
    Nav,
  },
  data() {
    return {
      menu: [],
      show: false,
    };
  },
  created() {
    let router = this.$router.options.routes;
    this.menu = router.filter((item) => item.hide === false) || [];
  },
  methods: {
    onJump(path, type) {
      if (type == 0) {
        //埋点
        this.$collect(15, null, "/article/page", null, "电子报");
      } else if (type == 1) {
        //埋点
        this.$collect(16, null, "/article/page", null, "路演");
      }
      this.show = false;
      window.open(path);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
